import { head } from 'ramda'
import React from 'react'

import { useMultiSelectState } from '../../../../packages/kiti/components/multiSelect/MultiSelectHandler'
import { usePlaceLevelsActionsList } from '../../../../utils/actions/placeLevels/list'
import { usePlaceLevelsState } from '../_load/PlaceLevelsLoader'
import MultiSelectMenu from '../../../../packages/kiti/components/multiSelect/MultiSelectMenu'

const MultiRowsActions = () => {
  const { placeLevels } = usePlaceLevelsState()
  const { selecteds, getSelectedData } = useMultiSelectState()
  const selectedPlaceLevels = getSelectedData(placeLevels)
  const menuOptions = usePlaceLevelsActionsList(head(selectedPlaceLevels), selecteds)

  return <MultiSelectMenu options={menuOptions} />
}

export default MultiRowsActions
